export default {
  route: {
    dashboard: '控制台',
    profile: '我的信息',

    icons: '图标',

    system: '系统配置',
    setting: '网站设置',
    config: '配置管理',
    menu: '菜单管理',
    attachment: '附件管理',

    permission: '权限管理',
    admin: '管理员',
    adminIndex: '管理员列表',
    authGroup: '管理分组',
    authGroupTree: '分组结构',
    authRule: '权限路由',
    authRuleTree: '权限结构',
    adminLog: '操作日志',

    localExtension: '本地扩展',
    extension: '扩展管理'
  },
  navbar: {
    dashboard: '首页',
    logOut: '退出登录',
    profile: '我的信息',
    avatar: '修改头像',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '运营系统',
    logIn: '登录',
    username: '账号',
    password: '密码',
    captcha: '验证码',
    refreshCaptcha: '刷新验证码',
    refreshCaptchaTip: '点击刷新验证码'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },

  '清空缓存': '清空缓存',
  '清空网站缓存成功': '清空网站缓存成功',
  '提示': '提示',
  '确定': '确定',
  '取消': '取消',

  '提交': '提交'
}
